import { render, staticRenderFns } from "./ListadoInformeDiagnóstico.vue?vue&type=template&id=58c0c870&scoped=true"
import script from "./ListadoInformeDiagnóstico.vue?vue&type=script&lang=js"
export * from "./ListadoInformeDiagnóstico.vue?vue&type=script&lang=js"
import style0 from "./ListadoInformeDiagnóstico.vue?vue&type=style&index=0&id=58c0c870&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c0c870",
  null
  
)

export default component.exports